import AgregarPaciente from "./AgregarPaciente";
export default AgregarPaciente